<script lang="ts">
  import type { RecommendationProduct } from "../../../interfaces/RecommendationProduct"

  import Card from "../../Common/Card.svelte"
  import ProductSingleImage from "../ProductDetails/ProductSingleImage.svelte"
  import ProductVendor from "../ProductDetails/ProductVendor.svelte"
  import ProductName from "../ProductDetails/ProductName.svelte"
  import ProductOptions from "../ProductDetails/ProductOptions.svelte"
  import ProductPrice from "../ProductDetails/ProductPrice.svelte"
  import ProductDescription from "../ProductDetails/ProductDescription.svelte"
  import ProductExpertMessage from "../ProductDetails/ProductExpertMessage.svelte"
  import BundledProductList from "../BundledProduct/BundledProductList.svelte";

  export let product: RecommendationProduct
</script>

<Card class="product-card">
  {#if product.bundledProducts}
    <BundledProductList
      bundledProducts={product.bundledProducts}
    />
  {:else}
    <ProductSingleImage product={product} class="product-info-image"/>
  {/if}
  <div class="product-card-content">
    <ProductVendor product={product} />
    <ProductName product={product} />
    <ProductOptions product={product} />
    <ProductPrice product={product} />
    <ProductDescription product={product} />
  </div>
</Card>
<ProductExpertMessage product={product}/>

<style lang="scss">
  :global(.product-info-image) {
    margin-bottom: 40px;
    width: 100%;
  }
</style>
